import { React, useState, useCallback } from "react";
import styles from "./adminPage.module.css";
import LanguagePalsComp from "../../../components/languagePals/LanguagePalsComp";
import LearningZonesComp from "../../../components/learningZonesComp/LearningZonesComp";
import { FaLock } from "react-icons/fa6";
import AdminSettings from "../../../components/adminSettings/AdminSettings";
import AdminStatistics from "../../../components/adminStatistics/AdminStatistics";
import AdminUsers from "../../../components/adminUsers/AdminUsers";
import { useUser } from "../../../storage/UserContext";

const AdminPage = () => {
  /* The Admin page is used by the website administrator to manage the website and its users. It contains 3 tabs: statistics (default), settings, and users */

  const [activeTab, setActiveTab] = useState("statistics");

  const { userData } = useUser();

  const currUsername = userData.username;

  const handleTabClick = useCallback((tab) => {
    setActiveTab(tab);
  }, []);

  return (
    <div className={styles.main}>
      {/* main layout  */}
      <section className={styles.mainLayout}>
        {/* left section  */}
        <div className={styles.left}>
          <LearningZonesComp />
        </div>
        {/* middle section  */}
        <div className={styles.middle}>
          <section className={styles.search}>
            <h1>
              Admin Dashboard{" "}
              <span className={styles.headerIcon}>
                <FaLock />
              </span>
            </h1>
            <div className={styles.searchArea}>
              <div className={styles.searchTabs}>
                <button
                  onClick={() => handleTabClick("statistics")}
                  className={`${styles.tabButton} ${
                    activeTab === "statistics" ? styles.active : ""
                  }`}
                >
                  Statistics
                </button>
                <button
                  onClick={() => handleTabClick("settings")}
                  className={`${styles.tabButton} ${
                    activeTab === "settings" ? styles.active : ""
                  }`}
                >
                  Settings
                </button>
                <button
                  onClick={() => handleTabClick("users")}
                  className={`${styles.tabButton} ${
                    activeTab === "users" ? styles.active : ""
                  }`}
                >
                  Users
                </button>
              </div>
              <div className={styles.content}>
                {activeTab === "statistics" && <AdminStatistics />}
                {activeTab === "settings" && <AdminSettings />}
                {activeTab === "users" && (
                  <AdminUsers currUsername={currUsername} />
                )}
              </div>
            </div>
          </section>
        </div>
        {/* right section  */}
        <div className={styles.right}>
          <LanguagePalsComp isOwn={true} />
        </div>
      </section>
    </div>
  );
};

export default AdminPage;
